import React, { useEffect, useState, useContext } from 'react';
import CornerWardrobeBodyConfig from './CornerWardrobeBodyConfig';
import SimpleWardrobeBodyConfig from './SimpleWardrobeBodyConfig';
import { EventsDataContext } from '../../contexts/EventsDataContext';
import { resetFrontsByType } from '../../store/actions/products';
import Loader from '../Loader';
import { connect } from 'react-redux';

const WardrobeBodyConfigs = props => {
  const { activeWardrobe, wardrobesConfigs, defaultCorner, resetFrontsByType } = props;

  const { optionsVisibility, setOptionsVisibility } = useContext(EventsDataContext);

  const [state, setState] = useState({
    typeChecked: false,
    isCorner: false,
    activeCorner: null,
  });

  useEffect(() => {
    if (wardrobesConfigs.length && !state.typeChecked) {
      const isCorner = wardrobesConfigs[activeWardrobe].is_corner;

      setOptionsVisibility({ ...optionsVisibility, optionsButton: false });

      setState({
        isCorner: isCorner,
        activeCorner: defaultCorner.type,
        typeChecked: true,
      });
    }

    resetFrontsByType();
    /* eslint-disable-next-line */
  }, [activeWardrobe, state, wardrobesConfigs, defaultCorner]);

  if (!state.typeChecked) {
    return <Loader />;
  }

  return (
    <div>
      {state.isCorner ? (
        <CornerWardrobeBodyConfig {...props} activeCorner={state.activeCorner} />
      ) : (
        <SimpleWardrobeBodyConfig {...props} />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    defaultCorner: state.defaults.corner,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetFrontsByType: () => dispatch(resetFrontsByType()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WardrobeBodyConfigs);
